<template>
  <!-- 广告 -->
  <div>
    <div class="main">
      <div class="breadcrumb">
        <span>首页</span>
        <span>></span>
        <span>广告</span>
      </div>
      <div class="main-content">
        <div class="content-l">
          <div class="privacy">
            <p>
              <strong>北京</strong>
            </p>
            <p>地址：中国北京朝阳区光华路2号阳光100G座7层（100026）</p>
            <p>广告热线：010-58685799</p>
            <p>传真：010-58685817</p>
            <p>
              <strong>上海</strong>
            </p>
            <p>地址：上海市静安区南京西路651号广电大厦3楼（200041）</p>
            <p>广告热线：021-220025509</p>
            <p>传真：021-22002262</p>
            <p>
              <strong>广州</strong>
            </p>
            <p>广州市越秀区大道中307号富力新天地中心4301（510100）</p>
            <p>广告热线：020-83731021</p>
            <p>传真：020-83731123</p>
          </div>
        </div>
        <div class="content-r">
          <Wechart></Wechart>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Wechart from "@/components/wechart";
import { getTdkList} from "@/api/tdk";
export default {
  components: {
    Wechart
  },
  data() {
    return {};
  },
  created() {
    getTdkList({column:0}).then(res => {
      console.log(res)
      const head = document.getElementsByTagName('head')
      const meta = document.createElement('meta')
      document.title= res.data.data[0].title;
      document.querySelector('meta[name="keywords"]').setAttribute('content',res.data.data[0].keyword)
      document.querySelector('meta[name="description"]').setAttribute('content', res.data.data[0].describe)
      head[0].appendChild(meta)
    })
  }
};
</script>
<style lang="scss" scoped>
.breadcrumb {
  color: #999999;
  font-size: 14px;
  line-height: 20px;
  padding-top: 20px;
  padding-bottom: 16px;
  span:last-child {
    color: #0091ff;
  }
}
.privacy {
  padding: 30px;
  background: #ffffff;
  margin-bottom: 60px;
  text-align: justify;
  p {
    font-size: 16px;
    margin-bottom: 10px;
    line-height: 36px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/footer/ad.vue